<template>
  <div class="inline">
    <a href="#" class="link-green" @click.prevent="show">
      <slot />
    </a>
    <modal width="65%"  height="90%" :name="name" class="relative">
        <button type="button" class="bg-red-500 hover:bg-red-600 rounded absolute right-0 top-0 mt-2 mr-2" @click="hide">
            <div class="text-white text-6xl p-3">
                <svg class="w-3 h-3 fill-current" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 348.333 348.334" style="enable-background:new 0 0 348.333 348.334;" xml:space="preserve">
<g><path d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85
c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563
c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85
l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554
L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"/></g>
</svg>
            </div>
        </button>
      <div class="px-6 py-8 overflow-auto h-full w-full ">
        <h1 class="title title-red md:text-3xl">Confection Menu</h1>

        <p class="mb-6">
          Over 25 food choices to pair with your order. Made fresh with quality ingredients. Available in a variety of different gift boxes, snack bags and tins. Please contact us for a quote on bulk candy.
        </p>

        <p class="mb-6">
          To create a new custom shape, call or email us for details.
        </p>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px">
          <tr class="">
            <td class="w-full" colspan="8">
                <img class="w-auto" src="/images/confections/row1.jpg">
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Jelly Bean Assortment</td>
            <td>Sour Patch Kids</td>
            <td>Gummy Bears</td>
            <td>Mike &amp; Ike&reg;</td>
            <td>Starburst</td>
            <td>Swedish Fish&reg;</td>
            <td></td>
          </tr>
          <tr>
            <td class="w-full" colspan="8"><img src="/images/confections/row2.jpg"></td>
          </tr>
          <tr>
            <td></td>
            <td>Smarties&reg;</td>
            <td>Skittles&reg;</td>
            <td>Reese's Pieces&reg;</td>
            <td>M&amp;Ms&reg;</td>
            <td>Goldfish&reg;</td>
            <td>Starzmania</td>
            <td></td>
          </tr>
          <tr>
            <td class="w-full" colspan="8"><img src="/images/confections/row3.jpg"></td>
          </tr>
          <tr>
            <td></td>
            <td>Dark Chocolate Almonds</td>
            <td>Bridge Mix</td>
            <td>Milk Chocolate Cashews</td>
            <td>Trail Mix-Cranberry Gold</td>
            <td>Deluxe Mixed Nuts</td>
            <td>Jumbo Cashews</td>
            <td></td>
          </tr>
          <tr>
            <td class="w-full" colspan="8"><img src="/images/confections/row4.jpg"></td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>Milk Chocolate Mini Pretzels</td>
            <td>English Butter Toffee</td>
            <td>Hershey's Kisses</td>
            <td>Jumbo Pistachios</td>
            <td>Gardetto Snack Mix</td>
            <td>Tootsie Rolls</td>
            <td>Dark Chocolate Espresso Beans</td>
          </tr>
        </table>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Custom Colored Candy</h1>

        <p class="mb-6">
          Don't see what you're looking for? Just ask! We have over 10,000 confectionery products available!
        </p>

        <p class="mb-6">
          Select up to 2 colors. PMS matches are approximate.
        </p>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Gourmet Jelly Beans</h1>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px">
          <tr>
            <td><img src="/images/confections/gourmet-beans/301.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/186.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/black.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/144.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/604.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/367.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/7442.jpg"></td>
            <td><img src="/images/confections/gourmet-beans/9061.jpg"></td>
          </tr>
          <tr>
            <td><strong>Blueberry</strong><br>PMS 301</td>
            <td><strong>Cherry</strong><br>PMS 186</td>
            <td><strong>Licorice</strong><br>Black</td>
            <td><strong>Tangerine</strong><br>PMS 144</td>
            <td><strong>Lemon</strong><br>PMS 604</td>
            <td><strong>Lime</strong><br>PMS 367</td>
            <td><strong>Bubblegum</strong><br>PMS 7442</td>
            <td><strong>Coconut</strong><br>PMS 9061</td>
          </tr>
        </table>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Jelly Belly® Beans</h1>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px">
          <tr>
            <td><img src="/images/confections/jelly-belly/272.jpg"></td>
            <td><img src="/images/confections/jelly-belly/483.jpg"></td>
            <td><img src="/images/confections/jelly-belly/200.jpg"></td>
            <td><img src="/images/confections/jelly-belly/1767.jpg"></td>
            <td><img src="/images/confections/jelly-belly/114.jpg"></td>
            <td><img src="/images/confections/jelly-belly/white.jpg"></td>
            <td><img src="/images/confections/jelly-belly/350.jpg"></td>
            <td><img src="/images/confections/jelly-belly/1495.jpg"></td>
          </tr>
          <tr>
            <td><strong>Island Punch</strong><br>PMS 272</td>
            <td><strong>Chocolate Pudding</strong><br>PMS 483</td>
            <td><strong>Cherry</strong><br>PMS 200</td>
            <td><strong>Bubblegum</strong><br>PMS 1767</td>
            <td><strong>Lemon</strong><br>PMS 114</td>
            <td><strong>Coconut</strong><br>White</td>
            <td><strong>Watermelon</strong><br>PMS 350</td>
            <td><strong>Tangerine</strong><br>PMS 1495</td>
          </tr>
          <tr>
            <td><img src="/images/confections/jelly-belly/354.jpg"></td>
            <td><img src="/images/confections/jelly-belly/1777.jpg"></td>
            <td><img src="/images/confections/jelly-belly/301.jpg"></td>
            <td><img src="/images/confections/jelly-belly/319.jpg"></td>
            <td><img src="/images/confections/jelly-belly/black.jpg"></td>
            <td colspan="3">&nbsp;</td>
          </tr>
          <tr>
            <td><strong>Green Apple</strong><br>PMS 354</td>
            <td><strong>Cotton Candy</strong><br>PMS 1777</td>
            <td><strong>Blueberry</strong><br>PMS 301</td>
            <td><strong>Berry Blue</strong><br>PMS 319</td>
            <td><strong>Licorice</strong><br>PMS Black</td>
            <td colspan="3">&nbsp;</td>
          </tr>
        </table>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Chocolate Covered Sunflower Seeds</h1>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px">
          <tr>
            <td><img src="/images/confections/sunflower-seeds/129.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/white.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/361.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/258.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/black.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/201.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/173.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/301.jpg"></td>
          </tr>
          <tr>
            <td><strong>Yellow</strong><br>PMS 129</td>
            <td><strong>White</strong></td>
            <td><strong>Lime Green</strong><br>PMS 361</td>
            <td><strong>Purple</strong><br>PMS 258</td>
            <td><strong>Black</strong></td>
            <td><strong>Red</strong><br>PMS 201</td>
            <td><strong>Orange</strong><br>PMS 173</td>
            <td><strong>Dark Blue</strong><br>PMS 301</td>
          </tr>
          <tr>
            <td><img src="/images/confections/sunflower-seeds/311.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/1895.jpg"></td>
            <td><img src="/images/confections/sunflower-seeds/673.jpg"></td>
            <td colspan="5">&nbsp;</td>
          </tr>
          <tr>
            <td><strong>Baby Blue</strong><br>PMS 311</td>
            <td><strong>Pink</strong><br>PMS 1895</td>
            <td><strong>Dark Pink</strong><br>PMS 673</td>
            <td colspan="5">&nbsp;</td>
          </tr>
        </table>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Chocolate Buttons</h1>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px">
          <tr>
            <td><img src="/images/confections/chocolate-buttons/207.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/1655.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/123.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/280.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/348.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/498.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/white.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/196.jpg"></td>
          </tr>
          <tr>
            <td><strong>Red</strong><br>PMS 207</td>
            <td><strong>Orange</strong><br>PMS 1655</td>
            <td><strong>Yellow</strong><br>PMS 123</td>
            <td><strong>Dark Blue</strong><br>PMS 280</td>
            <td><strong>Dark Green</strong><br>PMS 348</td>
            <td><strong>Brown</strong><br>PMS 498</td>
            <td><strong>White</strong></td>
            <td><strong>Lavender</strong><br>PMS 196</td>
          </tr>
          <tr>
            <td><img src="/images/confections/chocolate-buttons/black.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/3125.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/267.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/7530.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/544.jpg"></td>
            <td><img src="/images/confections/chocolate-buttons/211.jpg"></td>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td><strong>Black</strong></td>
            <td><strong>Turquoise</strong><br>PMS 3125</td>
            <td><strong>Purple</strong><br>PMS 267</td>
            <td><strong>Gray</strong><br>PMS 7530</td>
            <td><strong>Powder Blue</strong><br>PMS 544</td>
            <td><strong>Pink</strong><br>PMS 211</td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </table>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Fruit Sours</h1>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px">
          <tr>
            <td><img src="/images/confections/fruit-sours/312.jpg"></td>
            <td><img src="/images/confections/fruit-sours/200.jpg"></td>
            <td><img src="/images/confections/fruit-sours/2758.jpg"></td>
            <td><img src="/images/confections/fruit-sours/359.jpg"></td>
            <td><img src="/images/confections/fruit-sours/108.jpg"></td>
            <td><img src="/images/confections/fruit-sours/211.jpg"></td>
            <td><img src="/images/confections/fruit-sours/172.jpg"></td>
            <td><img src="/images/confections/fruit-sours/361.jpg"></td>
          </tr>
          <tr>
            <td><strong>Wildberry</strong><br>PMS 312</td>
            <td><strong>Cherry</strong><br>PMS 200</td>
            <td><strong>Grape</strong><br>PMS 2758</td>
            <td><strong>Margarita</strong><br>PMS 359</td>
            <td><strong>Lemon</strong><br>PMS 108</td>
            <td><strong>Watermelon</strong><br>PMS 211</td>
            <td><strong>Tangerine</strong><br>PMS 172</td>
            <td><strong>Green Apple</strong><br>PMS 361</td>
          </tr>
        </table>

        <hr class="break-bar">

        <h1 class="title title-red md:text-3xl">Saltwater Taffy</h1>

        <img src="/images/confections/saltwater-taffy.jpg">
        <ol class="mb-6 px-4" style="list-style-type: upper-alpha;column-count: 2;">
          <li>Strawberry</li>
          <li>Banana</li>
          <li>Blueberry</li>
          <li>Grape</li>
          <li>Watermelon</li>
          <li>Orange</li>
          <li>Caramel Swirl</li>
          <li>Licorice Swirl</li>
          <li>Strawberry/Banana</li>
          <li>Chocolate Mint</li>
          <li>Vanilla</li>
          <li>Cotton Candy</li>
        </ol>

      </div>
    </modal>

  </div>
 </template>

 <script>
   export default {
       // name: 'confection-choices',
     props: ['value'],

     computed: {
        name () {
          return `modal-${this.value}`
        }
     },

     methods: {
       show () {
         this.$modal.show(this.name);
       },
       hide () {
         this.$modal.hide(this.name);
       }
     }
   }
 </script>

<style scoped>
  table tr td {
    background: #fff!important;
  }
</style>
